import { useState } from "react";
import Logo from "../assets/logo/Logo";

export default function Footer() {
  return (
    <footer className="bg-tuncayBlue text-white py-6 mt-auto border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center text-center">
          <p className="text-sm opacity-80">
            &copy; {new Date().getFullYear()} Tuncay Seyahat. Tüm hakları
            saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
}
